import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserAddressForm } from "Bands/components";
import { editUserAddress, userAddressSelectorCreator } from "Bands/state";
import { USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons, IPlace } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Marker } from "shared/assets/icons";

const { userAddress: addressCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserAddressModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const addressIdSelector = useMemo(() => userAddressSelectorCreator(id), [id]);
  const address = useSelector(addressIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IPlace) => {
    dispatch(editUserAddress({ id, data }));
  };

  return (
    <UserEntityModal
      defaultValues={address}
      title={addressCopy.edit.title}
      icon={Marker}
      action={USER_ACTIONS.editUserAddress}
      buttons={buttons}
      successMessage={addressCopy.messages.edited}
      Component={UserAddressForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
